import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 12/13;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 12 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Docs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Doc" transform="translate(-437.000000, -531.000000)" fill={color}>
                <g id="Group-10" transform="translate(421.000000, 180.000000)">
                    <g id="Group-7" transform="translate(11.000000, 348.000000)">
                        <path d="M9.656,12.744 L15.656,6.744 L14.712,5.768 L9.656,10.84 L7.288,8.456 L6.344,9.4 L9.656,12.744 Z M15.656,3.4 C16.0293352,3.4 16.3466654,3.533332 16.608,3.8 C16.8693346,4.066668 17,4.38133152 17,4.744 L17,14.056 C17,14.4186685 16.8693346,14.733332 16.608,15 C16.3466654,15.266668 16.0293352,15.4 15.656,15.4 L6.344,15.4 C5.9706648,15.4 5.65333464,15.266668 5.392,15 C5.13066536,14.733332 5,14.4186685 5,14.056 L5,4.744 C5,4.38133152 5.13066536,4.066668 5.392,3.8 C5.65333464,3.533332 5.9706648,3.4 6.344,3.4 L15.656,3.4 Z" id="To-do"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconFormatTodo extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
